/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a color between HEX, RGB and HSL. Type any format or pick a color, and copy the value you need — with a live preview.`)
};

const es_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un color entre HEX, RGB e HSL. Escribe cualquier formato o elige un color y copia el valor que necesites — con una vista previa en vivo.`)
};

const de_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konvertieren Sie eine Farbe zwischen HEX, RGB und HSL. Geben Sie ein beliebiges Format ein oder wählen Sie eine Farbe aus, und kopieren Sie den benötigten Wert — mit einer Live-Vorschau.`)
};

const nl_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer een kleur tussen HEX, RGB en HSL. Typ elk formaat of kies een kleur en kopieer de waarde die u nodig hebt — met een live voorbeeld.`)
};

const fr_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez une couleur entre HEX, RGB et HSL. Tapez n'importe quel format ou choisissez une couleur, et copiez la valeur dont vous avez besoin — avec un aperçu en direct.`)
};

const it_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti un colore tra HEX, RGB e HSL. Digita qualsiasi formato o scegli un colore e copia il valore di cui hai bisogno — con un'anteprima dal vivo.`)
};

const pt_br2_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma cor entre HEX, RGB e HSL. Digite qualquer formato ou escolha uma cor e copie o valor que você precisa — com uma visualização ao vivo.`)
};

const pt_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma cor entre HEX, RGB e HSL. Escreva qualquer formato ou escolha uma cor e copie o valor que necessita — com uma pré-visualização em direto.`)
};

const ja_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HEX、RGB、HSLの間で色を変換します。任意の形式を入力するか色を選択し、ライブプレビュー付きで必要な値をコピーします。`)
};

const zh_cv_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在HEX、RGB和HSL之间转换颜色。输入任意格式或选取颜色，即可复制你所需的数值——并附带实时预览。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_intro", locale)
	if (locale === "en") return en_cv_intro(inputs)
	if (locale === "es") return es_cv_intro(inputs)
	if (locale === "de") return de_cv_intro(inputs)
	if (locale === "nl") return nl_cv_intro(inputs)
	if (locale === "fr") return fr_cv_intro(inputs)
	if (locale === "it") return it_cv_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cv_intro(inputs)
	if (locale === "pt") return pt_cv_intro(inputs)
	if (locale === "ja") return ja_cv_intro(inputs)
	return zh_cv_intro(inputs)
};